import { render, staticRenderFns } from "./RecyclableBoxExport.vue?vue&type=template&id=3481bc0c&scoped=true&"
import script from "./RecyclableBoxExport.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxExport.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableBoxExport.vue?vue&type=style&index=0&id=3481bc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481bc0c",
  null
  
)

export default component.exports